import { render } from "./Settings.vue?vue&type=template&id=b17299d4"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
script.render = render

export default script